import { render, staticRenderFns } from "./HedefPotansiyelCari.vue?vue&type=template&id=399fdfb2&scoped=true"
import script from "./HedefPotansiyelCari.vue?vue&type=script&lang=js"
export * from "./HedefPotansiyelCari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399fdfb2",
  null
  
)

export default component.exports